module.exports = __webpack_public_path__ + "static/media/settings.bab0d063.svg";